<template>
    <div>
        <h1 class="display-heading">{{pageTitle}}</h1>

        <div class="form-group">
            <label>Product Code</label>
            <input type="text" placeholder="Product Code" class="form-control" v-model="form.pc">
        </div>

        <div class="form-group">
            <label>Product Name</label>
            <input type="text" placeholder="Product Name" class="form-control" v-model="form.pn">
        </div>

        <!-- <div class="form-group">
            <label>Product Category</label>
            <input type="text" placeholder="Product Category" class="form-control" v-model="form.pcat">
        </div> -->

        <div class="form-group">
            <label>Active Ingredient</label>
            <input type="text" placeholder="Active Ingredient" class="form-control" v-model="form.ai">
        </div>

        <!-- <div class="form-group">
            <label>Conversion Factor</label>
            <input type="number" step="1"  placeholder="Conversion Factor" class="form-control" v-model="form.cf">
        </div> -->

        <div class="form-group">
            <label>Unit of Measurement</label>
            <input type="text" placeholder="Unit of Measurement" class="form-control" v-model="form.u">
        </div>

        <div class="form-group">
            <label>Min Order Quantity</label>
            <input type="text" placeholder="Min Order Quantity" class="form-control" v-model="form.moq">
        </div>

        <div class="form-group">
            <label>Unit Quantity</label>
            <input type="text" placeholder="Unit Quantity" class="form-control" v-model="form.uq">
        </div>

        <div class="form-group">
            <label>Unit Price</label>
            <input type="number" step=".01" placeholder="Price" class="form-control" v-model="form.up">
        </div>

        <div class="form-group">
            <label>Remarks</label>
            <input type="text"  placeholder="Remarks" class="form-control" v-model="form.r">
        </div>

        <p v-if="shouldShowSubmitMessage"
            :class="{
                'text-danger': submitHasError
            }">
            {{submitMessage}}
        </p>

        <div v-if="!isAddProduct">
            <button class="btn btn-primary btn-primary-insv" type="button" @click="saveChanges" :disabled="isSaving">Save Changes</button>
        </div>

        <div v-if="isAddProduct">
            <button class="btn btn-primary btn-primary-insv mr-2" type="button" @click="addNewDrug" :disabled="isSaving">Add Product</button>
            <router-link class="btn btn-secondary" :to="{'name': 'list-drugs'}">Cancel</router-link>
        </div>
    </div>
</template>

<script>
export default {
    'computed': {
        drugId () {
            return this.$route.name === 'drug-detail' ? this.$route.params.id : null;
        },
        isAddProduct () {
            return this.$route.name === 'drug-detail-add';
        },
        pageTitle () {
            return this.isAddProduct ? 'Add New Drug' : 'View / Edit Drug Details';
        },
        shouldShowSubmitMessage () {
            return this.submitMessage ? this.submitMessage.length > 0 : false;
        }
    },
    mounted () {
        if (!this.isAddProduct && this.drugId) {
            this.axios.get('Drugs/GetDrugDetails', {
                'params': {
                    'drugId': this.drugId
                }
            }).then(({
                data
            }) => {
                let drugData = data.data;
                this.form.di = drugData.di;
                this.form.pc = drugData.pc;
                this.form.pcat = drugData.pcat;
                this.form.pn = drugData.pn;
                this.form.ai = drugData.ai;
                this.form.u = drugData.u;
                this.form.cf = drugData.cf;
                this.form.up = drugData.up.toFixed(2);
                this.form.moq = drugData.moq;
                this.form.uq = drugData.uq;
                this.form.r = drugData.r;
            }).catch(() => {});
        }
    },
    data () {
        return {
            'form': {
                'di': null,
                'pc': null,
                'pcat': null,
                'pn': null,
                'ai': null,
                'u': null,
                'cf': 0,
                'moq': null,
                'uq': null,
                'r': null,
                'up': 0
            },
            'isSaving': false,
            'submitMessage': '',
            'submitHasError': false
        };
    },
    'methods': {
        saveChanges () {
            this.submitHasError = false;
            this.isSaving = true;
            this.submitMessage = 'Saving drug details...';
            this.axios.post('Drugs/SaveDrugDetails', this.form)
                .then(() => {
                    this.submitMessage = 'Drug details saved!';
                    this.$router.push(
                        {
                            'name': 'list-drugs'
                        });
                }).catch((error) => {
                    this.submitHasError = true;

                    if (error.response && error.response.data) {
                        this.submitMessage = error.response.data.message;
                    } else {
                        this.submitMessage = 'Error saving drug details... Please try again.';
                    }
                }).finally(() => {
                    this.isSaving = false;
                });
        },
        addNewDrug () {
            this.submitHasError = false;
            this.isSaving = true;
            this.submitMessage = 'Adding new drug...';
            this.axios.post('Drugs/AddNewDrug', this.form)
                .then(() => {
                    this.submitMessage = 'New drug added!';
                    this.$router.push(
                        {
                            'name': 'list-drugs'
                        });
                }).catch((error) => {
                    this.submitHasError = true;

                    if (error.response && error.response.data) {
                        this.submitMessage = error.response.data.message;
                    } else {
                        this.submitMessage = 'Error saving drug details... Please try again.';
                    }
                }).finally(() => {
                    this.isSaving = false;
                });
        }
    }
};

</script>

<style>

</style>
